"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validationConfig = exports.propsConfig = exports.popoverConfig = exports.payload = exports.initialValuesConfig = exports.initialTouchedConfig = exports.idPrefix = exports.dropdownOptions = exports.calcName = void 0;
var yup = _interopRequireWildcard(require("yup"));
var _sub = _interopRequireDefault(require("date-fns/sub"));
var _utils = require("../../middleware/utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var calcName = exports.calcName = 'requiredminimum';
var idPrefix = exports.idPrefix = 'rmd_';
var dropdownOptions = exports.dropdownOptions = {
  beneficiaryArray: ['my spouse', 'not my spouse'],
  returnRateArray: ['0%', '1%', '2%', '3%', '4%', '5%', '6%', '7%', '8%', '9%', '10%']
};
var popoverConfig = exports.popoverConfig = {
  spouseBirthdayInfo: "We ask for this information so we can determine which IRS life expectancy table to use in our calculations.",
  retirementAccountBalanceInfo: "This is the fair market value of your retirement accounts on 12/31 of last year, which you can find on your year-end statements. If you took a qualified charitable distribution, speak with a tax advisor about how to calculate your required minimum distribution.",
  requiredDistributionInfo: "The required minimum distribution for a given year is the account balance as of the end of the immediately preceding calendar year divided by a distribution period from the IRS's <a href='https://www.irs.gov/publications/p590b#en_US_2014_publink1000231236%3EJoint%20Life%20and%20Last%20Survivor%20Expectancy%20Table%3C/a%3E%20%E2%80%93%20if%20your%20spouse%20is%20the%20sole%20beneficiary%20and%20is%20more%20than%2010%20years%20younger%20%3Cnobr%3Ethan%20you%3C/nobr%3E%3C/li%3E%3Cli%3E%3Ca%20href=' target='_blank'>Uniform Lifetime Tables</a>. A separate table, available in the link above, is used if the sole beneficiary is the owner's spouse who is ten or more years younger than the owner."
};
var validationPage1 = yup.object().shape({
  birthMonth: yup.number('Month must be a number').required('You must specify a valid month').min(1, 'Invalid Month').max(12, 'Invalid Month'),
  birthDay: yup.number('Day must be a number').required('You must specify a valid day').min(1, 'Invalid Day').max(31, 'Invalid Day'),
  birthYear: yup.number().required('You must specify a valid year'),
  beneficiary: yup.string().required('You must select a beneficiary type').oneOf([dropdownOptions.beneficiaryArray]),
  spouseBirthMonth: yup.number().when('beneficiary', {
    is: beneficiary => beneficiary == 'my spouse',
    then: yup.number('Month must be a number').required('You must specify a valid month').min(1, 'Invalid Month').max(12, 'Invalid Month')
  }),
  spouseBirthDay: yup.number().when('beneficiary', {
    is: beneficiary => beneficiary == 'my spouse',
    then: yup.number('Day must be a number').required('You must specify a valid day').min(1, 'Invalid Day').max(31, 'Invalid Day')
  }),
  spouseBirthYear: yup.number().when('beneficiary', {
    is: beneficiary => beneficiary == 'my spouse',
    then: yup.number().required('You must specify a valid year')
  }),
  accountBalance: yup.number().transform(_utils.parseCurrencyString).required('Please enter a number between $0 and $25,000,000').min(0, 'Must be between $0 and $25,000,000').max(25000000, 'Must be between $0 and $25,000,000'),
  rateOfReturn: yup.string().required('You must select a rate').oneOf([dropdownOptions.returnRateArray]),
  birthdate: yup.date().typeError('Must be a valid date and between 18 and 100 years of age').required('Must be a valid date and between 18 and 100 years of age').min((0, _sub.default)(new Date(), {
    years: 100
  }), 'Must be a valid date and between 18 and 100 years of age').max((0, _sub.default)(new Date(), {
    years: 18
  }), 'Must be a valid date and between 18 and 100 years of age'),
  spouseBirthdate: yup.date().nullable().notRequired().when('beneficiary', {
    is: beneficiary => beneficiary == 'my spouse',
    then: yup.date().required('Must be a valid date and between 20 and 100 years of age').min((0, _sub.default)(new Date(), {
      years: 100
    }), 'Must be a valid date and between 20 and 100 years of age').max((0, _sub.default)(new Date(), {
      years: 20
    }), 'Must be a valid date and between 20 and 100 years of age')
  })
});
var validationConfig = exports.validationConfig = [validationPage1];
var initialValuesConfig = exports.initialValuesConfig = {
  birthMonth: '',
  birthDay: '',
  birthYear: '',
  beneficiary: 'my spouse',
  spouseBirthDay: '',
  spouseBirthMonth: '',
  spouseBirthYear: '',
  spouseBirthdate: '',
  accountBalance: '',
  rateOfReturn: '4%'
};
var initialTouchedConfig = exports.initialTouchedConfig = {
  birthMonth: false,
  birthDay: false,
  birthYear: false,
  spouseBirthDay: false,
  spouseBirthMonth: false,
  spouseBirthYear: false
};
var payload = exports.payload = {};
var propsConfig = exports.propsConfig = {
  config: {
    API_URL: 'https://maurice-api-dev.app.dx.nsawsdev.massmutual.com/calculator/datascience/calcs/v0/rmd',
    Icon: 'icon-bar-graph-alt-black',
    Label: 'Required Minimum Distribution Calculator',
    HasBorder: true,
    Steps: [{
      Title: 'What is my required minimum distribution?',
      Description: '',
      SecondaryDescription: "Use MassMutual's Required Minimum Distribution (RMD) Calculator to determine how much you must withdraw from your retirement account. Calculate RMD and understand the effect it will have on your account balance. It's important to note that this calculator assumes you are an account holder no longer contributing to your retirement account and do not own more than 5% of the business sponsoring the plan.",
      BackButton: {
        Label: '',
        Icon: '',
        Variant: ''
      },
      NextButton: {
        Label: 'Calculate',
        Icon: '',
        Variant: ''
      }
    }, {
      Title: 'Your required minimum distribution',
      Description: '',
      BackButton: {
        Label: 'Back',
        Icon: 'icon-arrow-spin-left',
        Variant: 'link'
      },
      NextButton: {
        Label: 'Edit your inputs & our assumptions',
        Icon: '',
        Variant: 'secondary',
        Side: 'L'
      },
      RightHandButton: {
        Label: 'View Disclosure',
        Href: '',
        Target: '',
        Variant: ''
      },
      SideContent: {
        Title: '',
        Description: '',
        CTAList: [{
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }, {
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }]
      }
    }]
  }
};